import { render, staticRenderFns } from "./_blog.vue?vue&type=template&id=78e495c4&scoped=true&lang=pug"
import script from "./_blog.vue?vue&type=script&lang=coffee"
export * from "./_blog.vue?vue&type=script&lang=coffee"
import style0 from "./_blog.vue?vue&type=style&index=0&id=78e495c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e495c4",
  null
  
)

/* custom blocks */
import block0 from "./_blog.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Wysiwyg: require('/opt/build/repo/site/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default,CraftVisual: require('/opt/build/repo/site/components/globals/craft-visual.coffee').default,ButtonVideoLauncher: require('/opt/build/repo/site/components/globals/button-video-launcher.vue').default,BlogSectionsList: require('/opt/build/repo/site/components/globals/blog-sections/list.vue').default,BlogSectionsCard: require('/opt/build/repo/site/components/globals/blog-sections/card.vue').default,SsrCarousel: require('/opt/build/repo/site/node_modules/vue-ssr-carousel/index.js').default,CarouselPagination: require('/opt/build/repo/site/components/globals/carousel-pagination.vue').default})
